/* eslint no-console: "off" */

/**
 * EventTracker.
 * Provides possibility to traks events.
 *
 * @copyright Realeyes OU. All rights reserved.
 */
export default class Logger {
    /**
     * @param {string} name is logger name and will be addad to every log string
     * @param {Boolean} isDebugMode enable debug level logging
     * Creates Logger instance.
     */
    constructor(name, isDebugMode = false) {
        this.creationTime = Date.now();
        this.isDebugMode = isDebugMode;
        this.name = name;
        this.console = window.console;
    }

    /**
     * @param{LogMessageTracker} tracker to be used to store/track log messages
     * Starts send logs to stream
     * @return {void}
     */
    setLogTracker(tracker) {
        this.tracker = tracker;
    }

    /**
     * Logs debug data.
     *
     * @param {Object} data is any data which should be logged
     * @return {void}
     */
    logDebug(data) {
        setTimeout(() => {
            if (this.isDebugMode) {
                this.console.debug(`${this.name} ${JSON.stringify(data || {})}`);
                this.log('debug', data);
            }
        }, 0);
    }

    /**
     * Logs info data.
     *
     * @param {Object} data is any data which should be logged
     * @return {void}
     */
    logInfo(data) {
        setTimeout(() => {
            this.console.log(`${this.name} ${JSON.stringify(data || {})}`);
            this.log('info', data);
        }, 0);
    }

    /**
     * Logs warnings data.
     *
     * @param {Object} data is any data which should be logged
     * @return {void}
     */
    logWarning(data) {
        setTimeout(() => {
            this.console.warn(`${this.name} ${JSON.stringify(data || {})}`);
            this.log('warning', data);
        }, 0);
    }

    /**
     * Logs error data.
     *
     * @param {Object} data is any data which should be logged
     * @return {void}
     */
    logError(data) {
        setTimeout(() => {
            const error = data;
            if (data instanceof Error) {
                error.message = `${this.name} ${error.message}`;
                this.console.error(error);
            } else {
                this.console.error(`${this.name} ${JSON.stringify(error || {})}`);
            }
            this.log('error', error);
        }, 0);
    }

    /**
     * Logs data.
     *
     * @param {string} level is description of the log message level
     * @param {Object} data is any data which should be logged
     * @return {void}
     */
    log(level, data) {
        if (this.tracker) {
            try {
                this.tracker.log(`DC SDK-${this.creationTime}`,
                    {
                        logSource: this.name,
                        logType: level,
                        clientTime: new Date(),
                        logMessage: data,
                    });
            } catch (exc) {
                if (console) {
                    // eslint-disable-next-line no-console
                    console.warn(exc);
                }
            }
        }
    }
}
